import React from "react";
import { Order } from "interfaces/commerce/order/order";
import styles from "./orders-modal-order-item.module.css";
import NavigateToInovioHostedPaymentPageButton
  from "components/payment-provider/inovio/navigate-to-inovio-hosted-payment-page-button.tsx";

interface OrderItemProps {
  order: Order;
}

const getStatusColor = (status: string, paymentStatus?: string) => {
  if (status === "COMPLETED") {
    return "#00AA00"; // Green
  }
  if (status === "EXPIRED") {
    return "#888888"; // Gray
  }
  if (status === "PROCESSING") {
    return "#4A90E2"; // Blue
  }
  if (status === "NEW") {
    if (paymentStatus === "PAYMENT_REQUIRED") {
      return "#FFA500"; // Orange
    }
    if (paymentStatus === "PENDING_CONFIRMATION") {
      return "#4A90E2"; // Blue
    }
  }
  if (status === "PAYMENT_FAILED") {
    return "#FF4444"; // Red
  }
  return "#666666"; // Default gray
};

const getStatusLabel = (status: string, paymentStatus?: string) => {
  if (status === "COMPLETED") {
    return "Completed";
  }
  if (status === "EXPIRED") {
    return "Expired";
  }
  if (status === "PROCESSING") {
    return "Processing";
  }
  if (status === "NEW") {
    if (paymentStatus === "PAYMENT_REQUIRED") {
      return "Payment Required";
    }
    if (paymentStatus === "PENDING_CONFIRMATION") {
      return "Processing";
    }
  }
  if (status === "PAYMENT_FAILED") {
    return "Payment Failed";
  }
  return status;
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const OrderItem: React.FC<OrderItemProps> = ({ order }) => {
  const statusColor = getStatusColor(order.status, order.payment_status);
  const statusLabel = getStatusLabel(order.status, order.payment_status);

  return (
    <div className={styles.orderItem}>
      <div className={styles.header}>
        <div className={styles.amount}>
          ${order.price.toFixed(2)}
        </div>
        <div 
          className={styles.status} 
          style={{ color: statusColor }}
        >
          {statusLabel}
        </div>
      </div>
      
      <div className={styles.productName}>
        {order.product ? order.product.name : "Deposit Funds"}
      </div>
      
      <div className={styles.details}>
        <div className={styles.detailRow}>
          <span className={styles.label}>Type:</span>
          <span className={styles.value}>
            {order.product ? "Product Purchase" : "Deposit"}
          </span>
        </div>
        
        <div className={styles.detailRow}>
          <span className={styles.label}>Date:</span>
          <span className={styles.value}>
            {formatDate(order.created_at)}
          </span>
        </div>
        
        {order.card_last4 && (
          <div className={styles.detailRow}>
            <span className={styles.label}>Payment:</span>
            <span className={styles.value}>
              Card ••••{order.card_last4}
            </span>
          </div>
        )}
      </div>
      
      {order.status === "NEW" && order.payment_status === "PAYMENT_REQUIRED" && order.payment_page_url && (
        <div className={styles.actionRow}>
          <NavigateToInovioHostedPaymentPageButton 
            title={"Complete Payment"}
            provideInovioHostedPaymentPageURL={() => Promise.resolve(order.payment_page_url)} 
          />
        </div>
      )}
      
      <div className={styles.footer}>
        <span className={styles.orderId}>
          ID: {order.id}
        </span>
      </div>
    </div>
  );
};

export default OrderItem;
